import {defineMessages} from 'react-intl';

export const INPUT_ICON_ACCESSIBILITY_TEXT = defineMessages({
  'title': {
    id: 'InputField.default.iconTitle',
    defaultMessage: 'Loading Spinner'
  },
  'desc': {
    id: 'InputField.default.iconDesc',
    defaultMessage: 'Input icon to show input state'
  },
  'loadingSpinnerDesc': {
    id: 'InputField.LoadingSpinner.iconDesc',
    defaultMessage: 'A loading image that rotates. Appears while information is being validated.'
  }
});
